import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// 抑制 redi 重复加载警告
if (typeof window !== 'undefined') {
  const originalWarn = console.warn
  const originalError = console.error
  
  console.warn = function(...args: unknown[]) {
    const message = args[0]
    if (typeof message === 'string' && message.includes('[redi]')) {
      // 抑制 redi 警告
      return
    }
    return originalWarn.apply(console, args)
  }
  
  console.error = function(...args: unknown[]) {
    const message = args[0]
    if (typeof message === 'string' && message.includes('[redi]')) {
      // 抑制 redi 错误
      return
    }
    return originalError.apply(console, args)
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
